<template>
  <div class="green-dragger-wrap" @click="progressJump" @mousedown="dragDown">
    <div class="progress-bar" :style="{width: progress + '%'}">
      <div class="progress-value-wrap">
        <img src="/images/offes-news-img/chevron-left-white.png" alt="<">
        <span class="percent-value">RD${{ currentValue }}</span>
        <img src="/images/offes-news-img/chevron-right-white.png" alt=">">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'green-dragger',
  props: {
    max: Number,
    current: Number,
    progress: Number,
    allowDrag: Boolean
  },
  data: () => {
    return {
      progressX: 0,
      currentValue: 0
    }
  },
  created: function () {
    setTimeout(() => {
      let bar = document.querySelector('.green-dragger-wrap')
      bar.style.maxWidth = bar.offsetWidth + 'px'
      this.valueContainerControl(bar.children[0])
    }, 1000)
  },
  methods: {
    onDrag: function (value) {
      this.$emit('value-changed', value)
    },
    progressJump: function (ev) {
        let barProgress = document.querySelector('.progress-bar')
        barProgress.style.width = `${ev.clientX - ev.target.offsetLeft}px`

        let bar = barProgress.parentElement
        let valueWrap = barProgress.children[0]
        let valueText = valueWrap.children[1]
        let currentPoint = this.progressX - bar.offsetLeft
        let percentage = (currentPoint / bar.offsetWidth) * 1
        let newValue = Math.round(this.max * percentage)
        let text = newValue < 0 ? 0 : (newValue > this.max ? this.max : newValue)

        barProgress.style.width = `${currentPoint}px`
        valueText.textContent = 'RD$' + text.toLocaleString()
        this.currentValue = text

        this.valueContainerControl(barProgress)
        this.onDrag(this.currentValue)
    },
    dragElement: function (ev) {
      ev = ev || window.event

      this.progressX = ev.clientX
      let elem = document.querySelector('.progress-bar')
      let bar = elem.parentElement
      let valueWrap = elem.children[0]
      let valueText = valueWrap.children[1]
      let currentPoint = this.progressX - bar.offsetLeft
      let percentage = (currentPoint / bar.offsetWidth) * 1
      let newValue = Math.round(this.max * percentage)
      let text = newValue < 0 ? 0 : (newValue > this.max ? this.max : newValue)

      elem.style.width = `${currentPoint}px`
      valueText.textContent = 'RD$' + text.toLocaleString()
      this.currentValue = text

      if (this.progressX < elem.parentElement.offsetLeft) elem.style.width = '0%'
      if (elem.offsetWidth >= elem.parentElement.offsetWidth) elem.style.width = '100%'

      this.valueContainerControl(elem)
    },
    closeDragging: function () {
      document.onmouseup = null
      document.onmousemove = null
      this.onDrag(this.currentValue)
    },
    dragDown: function (ev) {
        ev = ev || window.event
        ev.preventDefault()
        this.progressX = ev.clientX
        document.onmouseup = this.closeDragging
        document.onmousemove = this.dragElement
    },
    valueContainerControl: function (elem) {
      let bar = elem.parentElement
      let valueWrap = elem.children[0]

      if (valueWrap.offsetLeft < 0 || elem.offsetWidth < 50) {
        valueWrap.style.left = 0
      } else if (valueWrap.offsetLeft > (bar.offsetWidth - valueWrap.offsetWidth)) {
        valueWrap.style.left = (bar.offsetWidth - valueWrap.offsetWidth - 1) + 'px'
      } else valueWrap.style.left = elem.offsetWidth - 50 + 'px'

      setTimeout(() => {
        if (valueWrap.offsetLeft < 0 || elem.offsetWidth < 50) {
          valueWrap.style.left = 0
        } else if (valueWrap.offsetLeft > (bar.offsetWidth - valueWrap.offsetWidth)) {
          valueWrap.style.left = (bar.offsetWidth - valueWrap.offsetWidth - 1) + 'px'
        } else valueWrap.style.left = elem.offsetWidth - 50 + 'px'
      }, 300)
    }
  }
}
</script>

<style scoped>
  .green-dragger-wrap {
    background-color: #E1E1E1;
    height: 35px;
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
  }

  .progress-bar {
    background-color: #38B449;
    color: #fff;
    display: flex;
    position: relative;
    align-items: center;
    width: 12%;
    height: 100%;
  }

  .progress-value-wrap {
    background-color: #38B449;
    color: #fff;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #fff;
    height: 20px;
    padding: 0 8px;
    pointer-events: none;
    right: -50px;
    font-size: 10px;
    font-weight: 900;
    width: 84.91px;
    -webkit-transition: all .2s;
    transition: all .2s;
  }

  span.percent-value {
    margin: 0 7px;
  }
</style>



// WEBPACK FOOTER //
// green-dragger.vue?3c42185a